import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import customSelectStyles from '../SelectStyle';
import NotFound from "../Common/NotFound";

const { RangePicker } = DatePicker;

const ProfitSharingList = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [groupEmail, setGroupEmail] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [firstLoad, setFirstLoad] = useState(true);
    const [transactionType, setTransactionType] = useState('PROFIT_SHARING_BONUS');
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [statistic, setStatistic] = useState({
        total_adjust: 0,
        total_bonus: 0,
        total_crm_balance: 0,
        total_crm_deposit: 0,
        total_crm_withdraw: 0,
        total_lot_size: 0,
        total_mt5_balance: 0,
        total_mt5_deposit: 0,
        total_mt5_out: 0,
        total_mt5_withdraw: 0,
        total_profit_sharing: 0,
        total_reinvest: 0,
        total_lot_rebate_bonus: 0,
        total_same_rank_bonus: 0,
        total_contract_commission: 0,
        total_profit_sharing_bonus: 0,
    });
    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getTransactionList(event.selected + 1);
    }

    useEffect(() => {
        if(firstLoad){
            getTransactionList();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            let newData = { ...statistic };
            newData.total_profit_sharing_bonus = 0;
            setStatistic(newData);
            setPageNumber(1);
            getTransactionList(1);
        }
    }, [props.lang, from, to, productPerpage, email, groupEmail]);

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    }

    const getTransactionList = (page = pageNumber) => {
        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            let url = api.get_wallet_overview + `?page=${page}&order_by=DESC&sort_by=wallet_transaction_id`;

            if (from && to) {
                url += `&date_start=${from}&date_end=${to}`
            }
            if (productPerpage) {
                url += `&limit=${productPerpage}`
            }
            if (email) {
                url += `&email=${email}`
            }
            if (transactionType) {
                url += `&transaction_types=${transactionType}`
            }
            if (groupEmail) {
                url += `&group_email=${groupEmail}`
            }
            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
            })
                .then(response => response.json())
                .then(responseJson => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                    if (responseJson.status === "success") {
                        setStatistic(responseJson.data.statistic);
                        setResult(responseJson.data.results);
                        var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                        setPageCount(pageCount);
                        setTotalResultCount(responseJson.data.total_results)
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        console.log("error", responseJson.message);
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }, 1000);
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Date": entry.date_added,
                "Email": entry.email,
                "Name": entry.full_name ? entry.full_name : entry.nick_name,
                "Profit From": entry.remark_arr ? JSON.parse(entry.remark_arr).length > 1 ? JSON.parse(entry.remark_arr)[1] : '-' : '-',
                "Amount": Number(entry.amount).toLocaleString('en-US', digitFormat),
                "Lot Rebate": entry.lot_rebate ? entry.lot_rebate : '-',
                "Percentage": entry.same_rank_percentage,
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_wallet_overview + `?page=${pageCount}&order_by=DESC&sort_by=wallet_transaction_id&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }
                if (transactionType) {
                    url += `&transaction_types=${transactionType}`
                }
                if (groupEmail) {
                    url += `&group_email=${groupEmail}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'profit_sharing')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });

                
            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    return (
        <>
                <div className='pb-5 wallet'>
                    <Row className="mx-0 px-0 mt-3 mt-md-0">
                        <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                            <div className="whiteContainer px-md-4 py-md-4 p-2">
                                <div className="infoContainer">
                                    <div className="px-md-3 py-md-3 px-2 py-4">
                                        <Row className="mx-0 px-0">
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <span className="infoTitle">{translate(props.lang, "Profit Sharing Bonus List")}</span>
                                            </Col>
                                            <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                                <InfoBox
                                                    boxLabel={translate(props.lang, "Personal Profit Sharing Bonus")}
                                                    boxValue={statistic && statistic.total_profit_sharing && !groupEmail ? Number(statistic.total_profit_sharing).toLocaleString('en-US', digitFormat) : '0'}
                                                    loading={false}
                                                />
                                            </Col>
                                            <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                                <InfoBox
                                                    boxLabel={translate(props.lang, "Group Profit Sharing Bonus")}
                                                    boxValue={statistic && statistic.total_profit_sharing && groupEmail ? Number(statistic.total_profit_sharing).toLocaleString('en-US', digitFormat) : '0'}
                                                    loading={false}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className="tableContainer">
                                    <Row className="align-items-center mt-3">
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="groupLabel-input">
                                                <div className="input-group">
                                                    <Input
                                                        type="text"
                                                        placeholder={translate(props.lang, "Personal (Search By Email)")}
                                                        className="form-control input-transparent py-1 px-3"
                                                        onChange={e => setEmail(e.target.value ? e.target.value : '')}
                                                        value={email}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="groupLabel-input">
                                                <div className="input-group">
                                                    <Input
                                                        type="text"
                                                        placeholder={translate(props.lang, "Group (Search By Email)")}
                                                        className="form-control input-transparent py-1 px-3"
                                                        onChange={e => setGroupEmail(e.target.value ? e.target.value : '')}
                                                        value={groupEmail}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="">
                                                <RangePicker
                                                    className="w-100 input-transparent input-transparent"
                                                    placeholder={[
                                                        translate(props.lang, "From"),
                                                        translate(props.lang, "To"),
                                                    ]}
                                                    onChange={(e) => handleTimeChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Result Per Page")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                    name="productPerpage"
                                                    isSearchable={false}
                                                    onChange={(e) => setProductPerpage(e ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()} disabled={loadingExcel}>
                                                <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                            </button>
                                        </Col>
                                    </Row>
                                    <Table responsive className="w-100 table-list text-center position-relative">
                                        <thead>
                                            <tr>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Trx Date")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit From")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Amount")} (USD)</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit Sharing")} (USD)</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit Sharing Percentage")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit Sharing Bonus2")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit Sharing Same Rank Bonus Percentage")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan={9}>
                                                        <LoadingV3 theme='dark' />
                                                    </td>
                                                </tr>
                                            ) : (
                                                result.length > 0 ? (
                                                    result.map((item, i) => (
                                                        <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                            <td className={`font-weight-500 font-16 text-center text-black lh-base`}>{item.date_added ? item.date_added : ''}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.email ? item.email : '-'}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                            <td className={`font-weight-500 font-16 text-center px-1 description lh-base`}>{item.remark_arr ? JSON.parse(item.remark_arr).length > 1 ? JSON.parse(item.remark_arr)[1] : '-' : '-'}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.amount ? Number(item.amount).toLocaleString('en-US', digitFormat) : '-'}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.lot_size ? Number(item.lot_size).toLocaleString('en-US') : '-'}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.same_rank_percentage ? '-' : item.lot_rebate}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{!item.same_rank_percentage ? '-' : item.lot_rebate}</td>
                                                            <td className={`font-weight-500 font-16 text-center`}>{item.same_rank_percentage ? item.same_rank_percentage : '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr role="row" className={`even`}>
                                                        <td colSpan={9} >
                                                            <NotFound />
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="pt-4">
                                    {!loading && result.length > 0 ? (
                                        <div className="mt-3">
                                            <ReactPaginate
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                pageCount={pageCount}
                                                forcePage={pageNumber - 1}
                                                onPageChange={changePage}
                                                containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                                previousLinkClassName={"pagination__previouslink pagination-arrow text-black"}
                                                nextLinkClassName={"pagination__nextlink pagination-arrow text-black"}
                                                disabledClassName={"pagination__link--disabled text-muted"}
                                                activeClassName={"pagination__link--active text-black"}
                                                marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(ProfitSharingList);